// https://app.growthbook.io/features/pen-5950_v1
export const GIFTING_ON_MOBILE_NAV_FLAG_NAME = 'pen-5950_v1'
